module.exports = {"445322100":"都城镇","445322101":"平台镇","445322102":"桂圩镇","445322104":"通门镇","445322105":"建城镇","445322106":"宝珠镇","445322108":"大方镇","445322110":"千官镇","445322111":"大湾镇","445322112":"河口镇","445322113":"宋桂镇","445322114":"东坝镇","445322115":"连滩镇","445322116":"历洞镇","445322117":"南江口镇","445322400":"西江林场","445322401":"通门林场","445322402":"大历林场","445322403":"同乐林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445322.json
// module id = 1893
// module chunks = 0